import { Injectable } from '@angular/core';
import { UserService } from '../user/user.service';

@Injectable()
export class SidebarService {

  menu: any;

  menu_admin = [{
    titulo: 'sidebar.admin',
    icono: 'mdi mdi-wrench',
    submenu: [
        { titulo: 'sidebar.congresos', url: '/congresos' },
        { titulo: 'sidebar.categoriaInscripcion', url: '/categorias-inscripcion' },
        { titulo: 'sidebar.codigosInvitacion', url: '/codigos-invitacion' },
        { titulo: 'sidebar.actividades', url: '/actividades' },
        { titulo: 'sidebar.categoriaTrabajos', url: '/categorias-trabajos' },
        { titulo: 'sidebar.categoriaTrabajosInvitados', url: '/categorias-trabajos-invitados' },
        { titulo: 'sidebar.usuariosAdmin', url: '/usuarios-admin' }
    ]
}
];

menu_user = [{
  titulo: 'sidebar.acciones',
  icono: 'mdi mdi-check-circle-outline',
  submenu: [
      { titulo: 'sidebar.certificadoPago', url: '/certificado-pago' },
      { titulo: 'sidebar.certificadoCursos', url: '/certificados-cursos' },
      { titulo: 'sidebar.certificadoAsistencia', url: '/certificado-asistencia' }
  ]
}
];

  constructor(public _userService: UserService) { }

  loadMenu() {
    if ( this._userService.user.role === 'ADMIN_ROLE' ) {
      this.menu = this.menu_admin;
    } else {
      this.menu = this.menu_user;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/shared/sidebar.service.ts